<template>
  <div class="p-6">
    <h1 class="text-3xl font-bold mb-6">Uploaded Pages for {{ student.name }}</h1>

    <!-- This can be a simple list or a table similar to QuestionsPagesOverview -->
    <div v-if="pages.length > 0" class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
      <div v-for="page in pages" :key="page.id" class="border rounded-lg p-2 text-center">
        <a :href="getFileUrl(page.id)" target="_blank">
          <!-- PDF Icon -->
          <div v-if="page.mimeType === 'application/pdf'">
            <svg class="h-16 w-16 text-red-500 mx-auto" fill="currentColor" viewBox="0 0 20 20">...</svg>
            <p class="text-sm mt-2">Page {{ pages.indexOf(page) + 1 }}</p>
          </div>
          <!-- Image Thumbnail -->
          <img v-else :src="getThumbnailUrl(page.id)" class="w-full h-auto rounded"/>
        </a>
      </div>
    </div>
    <p v-else>No pages have been uploaded for this student yet.</p>
  </div>
</template>

<script setup>
// This component now just fetches and displays the list of uploaded pages for a student.
// It no longer needs to show extracted content.
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps({ studentId: String })
const route = useRoute()

const student = ref({})
const pages = ref([])

onMounted(async () => {
  // Fetch student details and their pages
})

const getFileUrl = (pageId) => `/api/tests/${route.params.testId}/students/${props.studentId}/pages/${pageId}/file`
// You will need backend endpoints for student pages, similar to question/rubric pages
</script>
